import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const user = await login(form.email, form.password);
      const dashboardRoles = ['seller', 'main_admin', 'local_admin'];
      navigate(dashboardRoles.includes(user.role) ? "/seller/dashboard" : from, {
        replace: true,
      });
    } catch (err) {
      setError(err.response?.data?.message || "Invalid credentials");
    }

    setLoading(false);
  };

  return (
    <div className="flex flex-grow">
      {/* LEFT SIDE IMAGE */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-lux-primary">
        <img
          src="https://images.unsplash.com/photo-1539008835657-9e8e9680c956?w=1200&q=80"
          alt="Luxury fashion"
          className="w-full h-full object-cover opacity-50"
        />

        <div className="absolute inset-0 flex flex-col justify-end p-16">
          <Link to="/" className="absolute top-12 left-12">
            <span className="font-display text-2xl text-white tracking-[0.15em]">
              AURÉNE
            </span>
          </Link>

          <h2 className="font-display text-5xl text-white font-light leading-[1.1] mb-4">
            Welcome
            <br />
            <em className="italic text-lux-gold">back.</em>
          </h2>

          <p className="font-body text-white/60 text-lg">
            Your style, your story — continued.
          </p>
        </div>
      </div>

      {/* RIGHT SIDE LOGIN FORM */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-8 py-16 bg-lux-bg">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden block mb-10">
            <span className="font-display text-2xl text-lux-primary tracking-[0.15em]">
              AURÉNE
            </span>
          </Link>

          <p className="label-sm text-lux-gold mb-2">Welcome Back</p>
          <h1 className="font-display text-4xl text-lux-primary mb-2">
            Sign In
          </h1>

          <p className="font-sans text-sm text-lux-secondary mb-10">
            Don't have an account?{" "}
            <Link
              to="/register"
              className="text-lux-primary hover:text-lux-gold underline underline-offset-2"
            >
              Create one
            </Link>
          </p>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 text-xs px-4 py-3 mb-6">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-8">
            <div>
              <label className="label-sm text-lux-secondary block mb-2">
                Email Address
              </label>

              <input
                type="email"
                value={form.email}
                onChange={(e) =>
                  setForm({ ...form, email: e.target.value })
                }
                placeholder="your@email.com"
                required
                className="input-lux"
              />
            </div>

            <div>
              <div className="flex justify-between items-center mb-2">
                <label className="label-sm text-lux-secondary">
                  Password
                </label>

                <Link
                  to="/forgot-password"
                  className="text-xs text-lux-secondary hover:text-lux-gold"
                >
                  Forgot password?
                </Link>
              </div>

              <input
                type="password"
                value={form.password}
                onChange={(e) =>
                  setForm({ ...form, password: e.target.value })
                }
                placeholder="••••••••"
                required
                className="input-lux"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full disabled:opacity-60"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}